/**
 * Platform data fetcher. In mock mode (the default for this pass)
 * the calls return the typed mock objects synchronously. When wired
 * to a live backend, swap to `apiFetch(...)` calls that hit the API.
 */
import {
  SUITES,
  BRIEF,
  PINNED,
  WORKSPACES,
  ALERTS,
  RECENT,
  USERS,
  ROLES,
  PERMS,
  AUDIT,
} from '../mocks/platform';
import type {
  Suite,
  Brief,
  PinnedItem,
  Workspace,
  AlertItem,
  RecentItem,
  User,
  Role,
  PermissionMatrix,
  AuditEntry,
} from '../types/platform';

export interface PlatformBundle {
  suites: Suite[];
  brief: Brief;
  pinned: PinnedItem[];
  workspaces: Workspace[];
  alerts: AlertItem[];
  recent: RecentItem[];
  users: User[];
  roles: Role[];
  perms: PermissionMatrix;
  audit: AuditEntry[];
}

export async function fetchPlatformBundle(): Promise<PlatformBundle> {
  // Mock mode — resolve synchronously, wrapped in a Promise to keep
  // the function signature ready for the live swap.
  return {
    suites: SUITES,
    brief: BRIEF,
    pinned: PINNED,
    workspaces: WORKSPACES,
    alerts: ALERTS,
    recent: RECENT,
    users: USERS,
    roles: ROLES,
    perms: PERMS,
    audit: AUDIT,
  };
}
